var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card text-center ml-4 mr-4 mt-4 bg-primary"},[_vm._v(" Closing Session... ")])}
var staticRenderFns = []

export { render, staticRenderFns }